{
  "actionbar.actions": "Azioni",
  "actionbar.actionsAvailable": "Azioni disponibili.",
  "actionbar.clearSelection": "Annulla selezione",
  "actionbar.selected": "{count, plural, =0 {Nessuno selezionato} one {# selezionato} other {# selezionati}}",
  "actionbar.selectedAll": "Tutti selezionati",
  "actionbutton.pending": "in sospeso",
  "breadcrumbs.more": "Altri elementi",
  "button.pending": "in sospeso",
  "calendar.invalidSelection": "{selectedCount, plural, one {Data selezionata non disponibile} other {Date selezionate non disponibili}}.",
  "combobox.loading": "Caricamento...",
  "combobox.loadingMore": "Caricamento altri...",
  "combobox.noResults": "Nessun risultato",
  "contextualhelp.help": "Aiuto",
  "contextualhelp.info": "Informazioni",
  "datepicker.endTime": "Ora di fine",
  "datepicker.startTime": "Ora di inizio",
  "datepicker.time": "Ora",
  "dialog.alert": "Avviso",
  "dialog.dismiss": "Ignora",
  "dropzone.replaceMessage": "Rilascia il file da sostituire",
  "inlinealert.informative": "Informazioni",
  "inlinealert.negative": "Errore",
  "inlinealert.notice": "Avvertenza",
  "inlinealert.positive": "Operazione riuscita",
  "label.(optional)": "(facoltativo)",
  "label.(required)": "(obbligatorio)",
  "listview.loading": "Caricamento...",
  "listview.loadingMore": "Caricamento altri...",
  "menu.loading": "Caricamento...",
  "menu.loadingMore": "Caricamento altri...",
  "menu.moreActions": "Altre azioni",
  "menu.noResults": "Nessun risultato",
  "menu.unavailable": "Non disponibile, espandi per i dettagli",
  "notificationbadge.indicatorOnly": "Nuova attività",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Caricamento...",
  "picker.loadingMore": "Caricamento altri...",
  "picker.placeholder": "Seleziona…",
  "picker.selectedCount": "{count, plural, =0 {Nessun elemento selezionato} one {# elemento selezionato} other {# elementi selezionati}}",
  "sidepanel.collapse": "Comprimi pannello laterale",
  "sidepanel.expand": "Espandi pannello laterale",
  "slider.maximum": "Massimo",
  "slider.minimum": "Minimo",
  "table.cancel": "Annulla",
  "table.drag": "Trascina",
  "table.editCell": "Modifica cella",
  "table.loading": "Caricamento...",
  "table.loadingMore": "Caricamento altri...",
  "table.resizeColumn": "Ridimensiona colonna",
  "table.save": "Salva",
  "table.sortAscending": "Ordinamento crescente",
  "table.sortDescending": "Ordinamento decrescente",
  "tag.actions": "Azioni",
  "tag.hideButtonLabel": "Mostra meno",
  "tag.noTags": "Nessuno",
  "tag.showAllButtonLabel": "Mostra tutto ({tagCount, number})",
  "toast.clearAll": "Cancella tutto",
  "toast.collapse": "Comprimi",
  "toast.showAll": "Mostra tutto",
  "treeview.loadingMore": "Caricamento altri..."
}
